import { FindingValidations } from '@/@types/persistUserValidations';

import type { FindingObject } from '../../types';

import { ValidationButton } from './ValidationButton';

interface Props {
  disabled?: boolean;
  item: FindingObject;
  onChange?: (item: FindingObject, value: FindingValidations) => void;
}

export const ConfirmRejectMonitor = ({ disabled, item, onChange }: Props) => {
  const handleChange = (value: FindingValidations) => {
    onChange?.(item, value);
  };

  return (
    <div className="vai-flex vai-justify-between vai-items-center vai-gap-8">
      {/* Confirm */}
      <ValidationButton
        disabled={disabled}
        isSelected={item.validation === FindingValidations.Agree}
        onClick={() => handleChange(FindingValidations.Agree)}
        value={FindingValidations.Agree}
      />
      {/* Reject */}
      <ValidationButton
        disabled={disabled}
        isSelected={item.validation === FindingValidations.Disagree}
        onClick={() => handleChange(FindingValidations.Disagree)}
        value={FindingValidations.Disagree}
      />
      {/* Monitor */}
      <ValidationButton
        disabled={disabled}
        isSelected={item.validation === FindingValidations.Monitor}
        onClick={() => handleChange(FindingValidations.Monitor)}
        value={FindingValidations.Monitor}
      />
    </div>
  );
};
